import React from 'react'
import { Button } from 'components/Form'
import { I18n } from 'react-redux-i18n'

const Buttons = (props) => {
  const { onSave, onCancel, isSubmitting } = props

  return (
    <div className='channel-field buttons'>
      <Button secondary value={I18n.t('dashboard_save')} onClick={onSave} isSubmitting={isSubmitting} />
      <Button value={I18n.t('dashboard_cancel')} onClick={onCancel} />
    </div>
  )
}

export default Buttons
